import {ref, computed, onMounted} from 'vue';
import http from '@/http.js';
import eventBus from '@/eventBus.js';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useRequetesList() {
    const filter = ref("");
    const requetes = ref([]);
    const perPage = ref(30);
    const currentPage = ref(1);

    const find = computed(() => {
        const page = currentPage.value > 1 ? (currentPage.value - 1) * perPage.value : 0;
        return requetes.value.slice(page, page + perPage.value);
    });

    const rows = computed(() => requetes.value.length);

    const resetFilter = () => {
        filter.value = "";
        getRequetes();
    };

    const searchRequetes = async () => {
        currentPage.value = 1;
        const data = await http.searchRequetes(filter.value);
        requetes.value = data;
    };

    const searchRequetesByKeyword = async () => {
        currentPage.value = 1;
        const data = await http.searchRequetesByKeyword(filter.value);
        requetes.value = data;
    };

    const getRequetes = async () => {
        const data = await http.getRequetes();
        requetes.value = data;
    };

    onMounted(() => {
        getRequetes();
        eventBus.on("reloadRequetes", getRequetes);
    });

    return {
        filter,
        requetes,
        perPage,
        currentPage,
        find,
        rows,
        resetFilter,
        searchRequetes,
        searchRequetesByKeyword,
    };
}

